<div class="content"> 
 
    <h4 style="margin-left: 20px;">Contractors</h4> 
     
    
    <!-- <h3>Raised Buttons</h3>
    <div class="example-button-row">
      <button mat-raised-button>Basic</button>
      <button mat-raised-button class="primary">Primary</button>
      <button mat-raised-button color="accent">Accent</button>
      <button mat-raised-button color="warn">Warn</button>
      <button mat-raised-button disabled>Disabled</button>
      <a mat-raised-button routerLink=".">Link</a>
    </div>
     <br> -->
    <br>
     
     

    <span style="margin-left: 10px;">
        <button mat-raised-button class="success" (click)="openProjectContractorAdd()" *ngIf="!showAvailbleMaterials">
          <mat-icon class="mr">add</mat-icon>Add Contrctors
          </button>
        
            <!-- <button mat-button color="success" (click)="toggleAvailbleMaterials()" *ngIf="showAvailbleMaterials">
              <mat-icon class="mr">menu</mat-icon>Done
              </button> -->
              </span>
      <br><br>
    
    <span *ngIf="!isMobile"> 
    <mat-table *ngIf="dataSource" [dataSource]="projectContractors" >
    
      
        <ng-container *ngFor="let column of ProjectContractorsColumns" [matColumnDef]="column">
      
          <th mat-header-cell *matHeaderCellDef style="width: 210px; text-transform: uppercase;" >
            <span *ngIf="column != 'imagecontent' && column != 'edit'">   {{ column }}</span> 
          
         </th> 
          <!-- <mat-header-cell *matHeaderCellDef>
        
        <td>{{ column }}</td>
        </mat-header-cell>  -->
      <!-- <mat-cell *matCellDef="let element">{{ element[column] }}</mat-cell>  -->
      
      
    <td mat-cell *matCellDef="let element">
      <div *ngIf="element !== editedRow; else editCell">
    
    
        <span  *ngIf="column == 'cost' || column == 'productPrice'">
        {{ element[column]  | currency }}   
     </span>
     <span  *ngIf="column != 'cost' && column != 'productPrice' && column != 'id'">
      {{ element[column] }}   
    </span>
     
        <span  *ngIf="column == 'edit'">
        <button mat-icon-button (click)="editRow(element)" >
        <mat-icon>edit</mat-icon>
         </button>
       
         <button mat-icon-button (click)="removeContractorfromProject(element)" >
          <mat-icon>delete</mat-icon>
           </button> 
       
        </span>


        <span *ngIf="column == 'imagecontent'" >
          <img src= {{element.imageContent}} width="40px" class="rounded-circle"/>
          </span>


      </div>
      <ng-template #editCell>
         
        <span *ngIf="column != 'edit'">
           <input [(ngModel)]="element[column]" title="save" (blur)="saveEdit(element)" />
           </span>
        <span *ngIf="column == 'edit'">
           <button mat-icon-button (click)="cancelEdit(element)">
          <mat-icon>done</mat-icon>
        </button>
        </span>
      </ng-template> 
    </td>
    
      </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="ProjectContractorsColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: ProjectContractorsColumns;"></tr>
      </mat-table>
    </span>
    
    <span *ngIf="isMobile">  
    
      <div *ngFor="let Contractor of projectContractors" class="card">
         
        <div class="card-content">
          
     <table><tr>
      <td style="text-align: left;"><a mat-fab class="custom-fab" (click)="removeContractorfromProject(Contractor)"><mat-icon>delete</mat-icon></a> </td>
      <td style="text-align: right;"> <a mat-fab class="custom-fab" (click)="editRow(Contractor)"><mat-icon>edit</mat-icon></a></td>
    </tr></table>
          
    
          <div class="card-row">
            <span class="card-label"><b>Title:</b></span>
            <span class="card-value">{{ Contractor.title}}</span>
          </div>
          <div class="card-row"> 
              <span class="card-label"><b>Date:</b></span>
              
            <span class="card-value">{{ Contractor.dueDate | date }}</span>
            
          </div>
            <div class="card-row">
            <span class="card-label"><b>Assigned To:</b></span>
              
            <span class="card-value">{{ Contractor.assignedTo }} </span>
            </div>
             
          <!-- </div>
          <div class="card-row"> -->
            <!-- <span class="card-label"><b>Qty:</b></span>
            <span class="card-value">{{ material.qty }}</span> -->
          </div>
          <ng-template #editCell>
         
            
            <input [(ngModel)]="Contractor.title" title="save" />
               <input [(ngModel)]="Contractor.title" title="save" (blur)="saveEdit(Contractor)" />
              
               <button mat-icon-button (click)="cancelEdit(Contractor)">
              <mat-icon>done</mat-icon>
            </button>
      
          </ng-template> 
        </div> 
      
    </span>
    
    
    
    
    
    
    
    
      
    </div>